import QueryString from 'qs';
import {
    ADD_QUERY_PARAMS,
    ADD_QUERY_FILTER_PARAM,
    SET_QUERY_SORT_PARAM,
} from '../actions/QueryActions';

export const generateFetchQuerySerialized = (condition = {}, filterParams = {}) => {
    let queryObject = Object.assign({}, condition, filterParams);

    return QueryString.stringify(queryObject);
};

export const cleanFilterParams = filterParams => {
    let params = {};

    for (let param in filterParams) {
        if (!filterParams[param]) {
            continue;
        }

        if (param === 'sort') {
            continue;
        }

        params[param] = filterParams[param];
    }

    return params;
};

// The order-list filter vocabulary this reducer owns. The URL query string is
// shared: payment-return markers (?payment=…), UTM tags and other concerns also
// live there. QueryReducer must read, serialize and re-write ONLY these keys —
// capturing the whole query string leaks foreign params into both the orders
// API request (fetchQuerySerialized) and the URL, where the pushState rebuild
// below resurrects them on every filter/sort/pagination change.
export const FILTER_KEYS = ['status', 'search', 'page', 'per-page', 'sort'];

let uri = window.location.href.split('?')[1];
let searchParams = new URLSearchParams(uri);
let filterParams = {};
let sortDirection;

for (let param of searchParams) {
    let [key, value] = param;

    if (!FILTER_KEYS.includes(key)) {
        continue;
    }

    if (key === 'sort') {
        sortDirection = value;
        continue;
    }

    Object.assign(filterParams, {[key]: value});
}

export const getFilterParam = paramName => {
    return filterParams[paramName] || undefined;
};

const fetchQuerySerialized = generateFetchQuerySerialized(filterParams);

const initialState = {
    pagination: {},
    condition: {},
    sortDirection: sortDirection,
    filterParams: filterParams,
    fetchQuerySerialized: fetchQuerySerialized,
    urlQuerySerialized: fetchQuerySerialized,
};

export default function QueryReducer(state = initialState, action) {
    let newState;
    let {type, payload} = action;

    switch (type) {
        case ADD_QUERY_FILTER_PARAM:
            let value = Object.values(payload)[0];
            let key = Object.keys(payload)[0];

            if (value === '') {
                delete state.filterParams[key];

                newState = Object.assign({}, state, {
                    filterParams: state.filterParams,
                });

                break;
            }

            newState = Object.assign({}, state, {
                filterParams: Object.assign(state.filterParams, payload),
            });

            break;

        case ADD_QUERY_PARAMS:
            newState = Object.assign({}, state, {
                filterParams: Object.assign(state.filterParams, payload),
            });

            break;

        case SET_QUERY_SORT_PARAM:
            newState = Object.assign({}, state, {
                sortDirection: payload.sortDirection,
            });

            break;
    }

    if (type.search('SUCCESS') >= 0) {
        if (payload && payload.pagination && Object.keys(payload.pagination).length !== 0) {
            newState = Object.assign({}, state, {
                pagination: payload.pagination,
            });
        }
    }

    if (newState) {
        let {condition, filterParams, sortDirection} = newState;
        let query;
        let clearFilterParams;

        clearFilterParams = cleanFilterParams(filterParams);

        if (sortDirection) {
            Object.assign(clearFilterParams, {sort: sortDirection});
        }

        query = generateFetchQuerySerialized(clearFilterParams);

        // Pure: only computes the serialized filter query. Writing it to the URL
        // is a side effect owned by queryUrlSyncMiddleware, which reflects
        // `urlQuerySerialized` into window.history.
        return Object.assign({}, newState, {
            fetchQuerySerialized: generateFetchQuerySerialized(condition, clearFilterParams),
            urlQuerySerialized: query,
        });
    }

    return state;
}